export const CARD_INCOME = 6001;
export const CARD_WITHDRAW = 6002;
export const WALLET_INCOME = 6003;
export const WALLET_WITHDRAW = 6004;
export const REFUND = 6005;
export const PRE_AUTHORIZATION = 6006;
export const CANCEL_PRE_AUTHORIZATION = 6007;
export const CREATED_BILL = 6009;
export const PAID_BILL = 6010;
export const BILL_BY_TEMPLATE = 6014;
export const P2P = 6015;
